const TacticSVG = () => {
  return (
    <svg
      width="100%" /* fits the width of the SVG to the container */
      height="100%" /* fits the height of the SVG to the container */
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className=" translate-x-[6%]">
      {/* <!-- Point 1: Rounded Hexagon (Green) --> */}
      <path
        d="M113.25 5.67062L178.678 43.4454C188.424 49.0723 194.428 59.4713 194.428 70.7252V146.275C194.428 157.529 188.424 167.928 178.678 173.555L113.25 211.329C103.504 216.956 91.4961 216.956 81.75 211.329L16.3221 173.555C6.57601 167.928 0.572144 157.529 0.572144 146.275V70.7252C0.572144 59.4713 6.57601 49.0723 16.3221 43.4454L81.75 5.67061C91.4961 0.0436816 103.504 0.043684 113.25 5.67062Z"
        className="fill-neutralLight"
        stroke="black"
        transform="translate(0,20) scale(0.35)"
      />

      {/* <!-- Point 2: Rounded Hexagon (Pink) --> */}
      <path
        d="M113.25 5.67062L178.678 43.4454C188.424 49.0723 194.428 59.4713 194.428 70.7252V146.275C194.428 157.529 188.424 167.928 178.678 173.555L113.25 211.329C103.504 216.956 91.4961 216.956 81.75 211.329L16.3221 173.555C6.57601 167.928 0.572144 157.529 0.572144 146.275V70.7252C0.572144 59.4713 6.57601 49.0723 16.3221 43.4454L81.75 5.67061C91.4961 0.0436816 103.504 0.043684 113.25 5.67062Z"
        className="fill-neutralDark"
        stroke="black"
        transform="translate(100, 30) scale(0.4)"
      />

      {/* <!-- Point 3: Rounded Hexagon (Yellow) --> */}
      <path
        d="M113.25 5.67062L178.678 43.4454C188.424 49.0723 194.428 59.4713 194.428 70.7252V146.275C194.428 157.529 188.424 167.928 178.678 173.555L113.25 211.329C103.504 216.956 91.4961 216.956 81.75 211.329L16.3221 173.555C6.57601 167.928 0.572144 157.529 0.572144 146.275V70.7252C0.572144 59.4713 6.57601 49.0723 16.3221 43.4454L81.75 5.67061C91.4961 0.0436816 103.504 0.043684 113.25 5.67062Z"
        className="fill-neutralLight"
        stroke="black"
        transform="translate(50,110) scale(0.4)"
      />

      {/* <!-- Connection line between Hexagon 1 (Green) and Hexagon 3 (Yellow) --> */}
      <line
        x1="35"
        y1="55"
        x2="90"
        y2="150"
        stroke="#00D1FF"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="6, 8"
      />
    </svg>
  );
};

export default TacticSVG;
